import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const admin = {
  main: () => import('@/components/routed/Admin/Main.vue'),
  applicants: () => import('@/components/routed/Admin/Applicants.vue'),
}

const _public = {
  main: () => import('@/components/routed/Public/Main.vue'),
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: _public.main,
    },
    {
      path: '/admin',
      component: admin.main,
      children: [{
        path: 'applicants',
        name: 'AdminApplicants',
        component: admin.applicants,
        meta: {
          transIndex: 70,
          roles: ['ADMIN'],
        },
      },
      {
        path: '/',
        beforeEnter (to, from, next) {
          next({name: 'AdminApplicants'}) //prevents /admin from navigating to nothing
        }
      }],
    },
  ]
})

router.beforeEach((to, from, next) => {
  // /* eslint-disable */
  // return next()

  const store = require('./store.js').default
  
  const roles = to.meta.roles
  if (!roles) return next()

  const user = store.state.user
  if (!(user && roles.includes(user.role))) return next({name: 'Login', query: {redirect: to.fullPath}})
  
  next()
})

export default router